import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { FooterButtonStyled } from '~/styled';
import { UpdateProjectModulesErrorProps } from './types';
import { UpdateModuleError } from '@bechtel/types';

const getErrorMessage = (error: UpdateProjectModulesErrorProps['updateModuleError']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case UpdateModuleError.NOT_FOUND:
      return <Trans>Module not found.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

const UpdateProjectModulesError: FC<UpdateProjectModulesErrorProps> = ({ updateModuleError, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} data-testid="qty-config-error" style={{ width: '552px', height: '275px' }}>
      <ModalHeader title={t`Update Modules Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(updateModuleError)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <FooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </FooterButtonStyled>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};

export default UpdateProjectModulesError;
